// extracted by mini-css-extract-plugin
export default {"content":"iD1lepdDDxucpaluE4fd","delete-version":"JjrHFmQ6qYPRmIeeF0Cw"};